import { FileDocumentType } from '@nkr/enums/document-type';
import { toast } from 'react-toastify';

export async function openWatrReceiptInSidebar(
    downloadFile: (docType: number, lookupId: number) => Promise<any>,
    onShowDataSideBar: (docType: number, lookupId: number, fileUrl: string) => void,
    fileId: number
): Promise<void> {
    const showFileMissingToast = (message?: string) => {
        toast.error(message && message.trim().length > 0 ? message.trim().slice(0, 300) : 'Unable to locate file.');
    };

    try {
        const response = await downloadFile(FileDocumentType.Receipts, fileId);
        const blob: Blob | undefined = response?.data;

        if (!response || response.status < 200 || response.status >= 300) {
            showFileMissingToast();
            return;
        }
        if (!blob || blob.size === 0) {
            showFileMissingToast();
            return;
        }

        const type = blob.type || '';
        const looksTextError =
            type.startsWith('text/')
            || type === 'application/problem+json'
            || type === 'application/json';

        if (looksTextError) {
            const text = await blob.text();
            showFileMissingToast(text);
            return;
        }

        if (blob.size <= 512 && (!type || type === 'application/octet-stream')) {
            const peek = await blob.slice(0, Math.min(blob.size, 256)).text();
            if (/unable to locate file|bad request/i.test(peek.trim())) {
                showFileMissingToast(peek.trim());
                return;
            }
        }

        const fileUrl = URL.createObjectURL(blob);
        onShowDataSideBar(FileDocumentType.Receipts, fileId, fileUrl);
    } catch (err: any) {
        console.error('openWatrReceiptInSidebar:', err);
        if (err?.response?.data instanceof Blob) {
            try {
                const text = await err.response.data.text();
                showFileMissingToast(text);
            } catch {
                showFileMissingToast();
            }
        } else {
            const data = err?.response?.data;
            showFileMissingToast(typeof data === 'string' ? data : undefined);
        }
    }
}
